
























import { Component, Vue } from 'vue-property-decorator';
import { TreeViewPlugin } from '@syncfusion/ej2-vue-navigations';
import MainLayout from '../../layouts/MainLayout.vue';
import IDict from '@/types/IDict';
import IWordFilter from '@/types/IWordFilter';
import WordFilter from '@/utils/WordFilter';
import WordDictionary from '@/utils/WordDictionary';

Vue.use(TreeViewPlugin);

// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    MainLayout,
    TreeViewPlugin,
  },
})
export default class FilterPage extends Vue {
  fields: IWordFilter;
  dict: IDict;
  filterTitle: string;

  constructor() {
    super();

    this.filterTitle = 'Filter by Group';

    this.dict = WordDictionary.loadHistory();
    this.fields = WordFilter.dictToFilter(this.dict);
  }

  static getTreeViewObject(): any {
    // give up on typescript checking of opaque vendor types
    const treeElem: HTMLElement | null = document.getElementById('treeview');
    return (treeElem as any).ej2_instances[0];
  }

  // allow click on text to work as if on checkbox
  onNodeClicked(args: { event: Event, node: object }): void {
    // checks just to get lint to shut up
    if (!(args && args.event && args.event.target && this.fields)) {
      return;
    }

    const target = args.event.target as HTMLElement;
    if (target.classList.contains('e-fullrow')) {
      const treeObj = FilterPage.getTreeViewObject();

      // give up on typescript checking of opaque vendor types
      const nodeDetails = treeObj.getNodeData(args.node) as any;
      const checkedNode = [args.node];
      if (nodeDetails && nodeDetails.isChecked === 'true') {
        treeObj.uncheckAll(checkedNode);
      } else {
        treeObj.checkAll(checkedNode);
      }
    }
  }

  onNodeChecked(args: any): void {
    // skip indirect events which are just to cascade changes up the tree
    if (!args.isInteracted) {
      return;
    }
    const treeObj = FilterPage.getTreeViewObject();
    const { checkedNodes } = treeObj;
    const itemHashCodes: number[] = [];

    // look up hashcodes corresponding to checked items
    checkedNodes.forEach((node: any) => {
      const itemId = parseInt(node, 10);
      const match = this.fields.dataSource[itemId];
      if (match && match.hashCode) {
        itemHashCodes.push(match.hashCode);
      }
    });

    // update matches by hash code in dictonary
    WordFilter.applyFilter(this.dict, itemHashCodes);
    WordDictionary.saveHistory(this.dict);
  }
}
